import { Box, NavButtonLink, Stack } from '@/primitives';
import { useShell } from '@/providers';
import { NavItem } from './ShellNavItems';
import { blue } from '@/lib/colours';
import { forwardRef } from 'react';

interface Props {
  items: NavItem[];
}

export default forwardRef<HTMLDivElement, Props>(function ShellSubNavItems(
  { items }: Props,
  ref,
) {
  const { sidebarExpanded } = useShell();

  return (
    <Box
      ref={ref}
      sx={{
        ...(sidebarExpanded
          ? {
              div: {
                a: {
                  height: '56px',
                  pl: '66px',
                },
              },
            }
          : {
              div: {
                a: {
                  p: '12px 12px 12px 52px',
                  height: '56px',
                },
              },
            }),
      }}
    >
      <Stack
        sx={{
          width: '256px',
          ...(!sidebarExpanded && {
            borderRadius: '4px',
            background: blue[900],
          }),
          '& > a': { height: '64px' },
        }}
      >
        {items.map(({ expanded, label, subnavs, ...rest }, index) => (
          <NavButtonLink isSubnav key={index} {...rest}>
            {label}
          </NavButtonLink>
        ))}
      </Stack>
    </Box>
  );
});
